export default __webpack_public_path__ + "static/media/shh.4e26125e.png";